import { Settings, Wrench } from "lucide-react";
import { NavLink } from "react-router-dom";

import { useIsSuperAdmin } from "@/api/is-superadmin";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { cn } from "@/lib/utils";
import { NavigationItem } from "@/types/navigation";
import { RoleEnum } from "@classview/shared-types";

import { UserProfileMenu } from "./user-profile-menu";

export function SecondarySidebar() {
  const { isSuperAdmin } = useIsSuperAdmin();
  const { hasPermission } = useOrganisation();

  const navigation: NavigationItem[] = [
    ...(isSuperAdmin
      ? [{ name: "Super Admin", href: "/admin", icon: Wrench }]
      : []),
    ...(hasPermission(RoleEnum.USER_MANAGEMENT)
      ? [{ name: "Settings", href: "/settings", icon: Settings }]
      : []),
  ];

  return (
    <div>
      <nav className="flex flex-1 flex-col">
        <ul role="list" className="flex flex-1 flex-col gap-y-7">
          <li>
            <ul role="list" className="-mx-2 space-y-1">
              {navigation.map((item) => (
                <li key={item.name}>
                  <NavLink
                    to={item.href}
                    className={({ isActive }) =>
                      cn(
                        isActive
                          ? "is-active border-border bg-background text-primary shadow-sm"
                          : "border-transparent text-muted hover:text-foreground",
                        "text-md group flex gap-x-3 rounded-sm border p-2 font-semibold leading-6",
                      )
                    }
                  >
                    {item.icon && (
                      <item.icon
                        aria-hidden="true"
                        className={cn(
                          "h-6 w-6 shrink-0",
                          "text-muted",
                          "group-hover:text-foreground group-[.is-active]:text-primary",
                        )}
                      />
                    )}
                    {item.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </nav>
      <div className="mt-6">
        <UserProfileMenu />
      </div>
    </div>
  );
}
